import { createFileRoute } from '@tanstack/react-router'

import DetailSwadayaPage from '@/components/pages/backoffice/_ktg-penyuluh/swadaya/_swadayaId/containers/DetailSwadayaPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/'
)({
  component: DetailSwadayaPage
})
